<template>
  <div v-if="visible" class="privacy-overlay" >
    <div class="privacy-dialog" role="dialog" aria-modal="true" style="width: 600px;">
      <button class="privacy-close" @click="disagree" aria-label="关闭">×</button>
      <h3 class="title" style="text-align: center;">个人信息保护及隐私政策情况说明</h3>
      <div ref="content" class="privacy-content" @scroll="onScroll" style="max-height: 280px; overflow-y: auto; line-height: 1.8;">
        <!-- <PrivacyPage class="privacy-page-content" :show-title="false" /> -->
          <p>欢迎您使用MOVIBOT！</p>
          <p>我们非常重视您的个人信息保护，将依据法律法规要求，采取相应安全保护措施尽力保护您的个人信息安全。鉴此，我们制定本<router-link to="privacy"  target="_blank" style="color: #2655ae;">《个人信息保护及隐私政策》</router-link>（简称“本政策”），并提醒您：</p>
          <p>本政策对您使用我们的产品或者服务非常重要，请您在使用我们的产品或者服务之前务必仔细阅读全部内容。我们会尽量使用通俗易懂、简明扼要的方式来描述相关内容，以便于您理解收集个人信息的目的，收集、使用的个人信息及方式，以及您管理这些信息的途径和方式。</p>
          <p>我们将按照本政策收集、使用您的个人信息，以便向您提供相关产品或者服务。如对本政策内容有任何疑问、意见或建议，您可通过本政策明示的联系方式与我们联系，我们会尽快为您作出解答。</p>
      </div>
      <div class="actions">
        <button  @click="disagree" class="button-jujue">拒绝</button>
        <!-- <button :disabled="!canAgree" @click="agree" :class="{disabled: !canAgree}">同意</button> --> <!--滚动到底部才可点击 -->
        <button  @click="agree" >同意并接受</button>
      </div>
    </div>
  </div>
</template>

<script>
import PrivacyPage from "@/views/html/privacy.vue";

export default {
  name: "PrivacyModal",
  components: {
    PrivacyPage
  },
  data() {
    return {
      visible: false,
      canAgree: false
    };
  },
  mounted() {
    try {
      const accepted = localStorage.getItem("privacyAccepted");
      if (!accepted) {
        this.visible = true;
        this.$nextTick(() => this.checkScroll());
      }
    } catch (e) {
      this.visible = true;
    }
  },
  methods: {
    onScroll() {
      this.checkScroll();
    },
    checkScroll() {
      const el = this.$refs.content;
      if (!el) return;
      // 当滚动到底部时允许同意
      this.canAgree = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
    },
    disagree() {
      try {
        localStorage.setItem("privacyAccepted", "2");
      } catch (e) {
        // ignore
      }
      this.visible = false;
      // TODO: 在此处调用后端接口记录用户同意状态（无论是否登录）
    },
    agree() {
    //   if (!this.canAgree) return;//阅读完
      try {
        localStorage.setItem("privacyAccepted", "1");
      } catch (e) {
        // ignore
      }
      this.visible = false;
      // TODO: 在此处调用后端接口记录用户同意状态（无论是否登录）
    }
  }
};
</script>

<style scoped>
.privacy-overlay {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.privacy-dialog {
  width: 80%;
  max-width: 600px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.2);
  overflow: hidden;
  /* height: 550px;  */
  display: flex;
  flex-direction: column;
  position: relative;
}
.privacy-close {
  position: absolute;
  right: 12px;
  top: 12px;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #999;
  font-size: 20px;
  line-height: 32px;
  cursor: pointer;
}
.privacy-close:hover {
  color: #333;
}
.title {
  margin: 16px;
  font-size: 18px;
}
.privacy-content {
  padding: 0 26px 16px 26px;
  overflow: auto;
  flex: 1 1 auto;
  line-height: 1.6;
}

.privacy-page-content {
  display: block;
}
.privacy-page-content :deep(.privacy) {
  padding-top: 0;
  padding-bottom: 0;
}
.privacy-page-content :deep(.title) {
  font-size: 18px;
  line-height: 1.4;
  text-align: left;
  margin-bottom: 12px;
}
.privacy-page-content :deep(.title-o) {
  font-size: 16px;
  margin-top: 12px;
}
.privacy-page-content :deep(.title-info) {
  font-size: 14px;
  line-height: 1.5;
  margin-top: 10px;
}
.actions {
  padding: 12px 16px;
  text-align: center;
  /* border-top: 1px solid #eee; */
}
.actions button {
  background: #2655ae;
  color: #fff;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.actions .button-jujue {
  background: #ffffff;
  color: #6a6b6d;
  padding: 8px 16px;
  border: 1px solid #999999;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
 
}

.actions .button-jujue:hover {
  background: RGB(236, 245, 255);
  color: #409Eff;
  padding: 8px 16px;
  border: 1px solid RGB(198, 226, 255);
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
 
}
.actions button.disabled {
  background: #ccc;
  cursor: not-allowed;
}
.actions button:disabled {
  background: #ccc;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/index/PrivacyModal.vue